import { FixtureViewType } from '@cds/betting-offer';
import { EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { IPickTracking } from '@frontend/sports/option/pick/feature/tracking';

import { BetslipPick } from './betslip-pick';
import { PickId } from './pick-id';
import { IPrice, PriceType } from './pick-models';
import { SignedName } from './signed-name.model';

export class BetslipUnknownPick extends BetslipPick {
    readonly legs: BetslipPick[];
    static isPick(pick: BetslipPick): pick is BetslipUnknownPick {
        return pick instanceof BetslipUnknownPick;
    }

    constructor(pickId: PickId, tracking?: IPickTracking, legs?: BetslipPick[]) {
        super();
        this.id = pickId;
        this.market = {
            id: 0,
            isVisible: false,
            isBetBuilderEnabled: false,
        };
        this.priceType = PriceType.NoPrice;
        this.acceptedPrice = {
            price: null,
            isManuallyAccepted: false,
        };
        this.isAvailable = false;
        this.tracking = tracking || { source: '' };
        this.legs = legs ?? [];
    }

    // this should not be used, we have the 'legs' field. It exists only because the GroupPicks has a similar function,
    // and it's convenient to combine if statements. IMO GroupPicks should also ditch it and use a readonly field
    getLegs(): BetslipPick[] {
        return this.legs;
    }

    override copy(): BetslipUnknownPick {
        const base = super.toJSON();

        const pick = new BetslipUnknownPick(PickId.Empty(), void 0, this.legs);
        pick.initPropertiesFromJSON(base);

        return pick;
    }

    override get eventParticipants(): EventParticipant[] | undefined {
        return undefined;
    }

    override get eventViewType(): FixtureViewType | undefined {
        return undefined;
    }

    override get eventName(): SignedName {
        return {
            name: '',
            signature: '',
        };
    }

    override get isLive(): boolean {
        return false;
    }

    override isMarketVisible(): boolean {
        return false;
    }

    protected override isPriceVisible(): boolean {
        return false;
    }

    override get isVirtual(): boolean {
        return false;
    }

    override get marketName(): SignedName {
        return {
            name: '',
            signature: '',
        };
    }

    override get eventDate(): Date {
        return new Date();
    }

    override get regionName(): SignedName {
        return {
            name: '',
            signature: '',
        };
    }

    override get competitionName(): SignedName {
        return {
            name: '',
            signature: '',
        };
    }

    override get competitionId(): number {
        return 0;
    }

    override get leagueName(): SignedName {
        return {
            name: '',
            signature: '',
        };
    }

    override get optionName(): SignedName {
        return {
            name: '',
            signature: '',
        };
    }

    override get prices(): IPrice[] {
        return [];
    }

    override get sportName(): SignedName {
        return {
            name: '',
            signature: '',
        };
    }

    override get partitionId(): number | undefined {
        return undefined;
    }

    override get sportId(): number {
        return 0;
    }
}
